import React from 'react'

export interface FilterMetaProps {
    className?: string
    primaryInfo?: React.ReactNode
    secondaryInfo?: React.ReactNode
    topLabel?: React.ReactNode
}

export function FilterMeta({
    className = 'FilterMeta',
    primaryInfo,
    secondaryInfo,
    topLabel,
}: FilterMetaProps) {
    return (
        <div className={`${className} pl-2`}>
            <p className={`text-xs text-neutral-400`}>{topLabel}</p>
            <p className="text-sm">{primaryInfo}</p>
            <p className={`text-xs text-neutral-400`}>{secondaryInfo}</p>
        </div>
    )
}
